import React, { useState, useRef, useMemo } from 'react';
import { Map, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import L from 'leaflet'; // eslint-disable-next-line
import icon from '../../assets/img/lodges/masonic_craft.png'; // eslint-disable-next-line
import iconShadow from '../../assets/img/lodges/masonic_craft.png'; // eslint-disable-next-line

let DefaultIcon = L.icon({
	iconUrl: icon,
	iconAnchor: null,
	popupAnchor: [-0, -0],
	shadowAnchor: null,
	iconSize: [45, 65]
});
L.Marker.prototype.options.icon = DefaultIcon;

//function DraggableMarker() {
const DraggableMarker = props => {
	const { lat, long, orgName, pageLanguageContent, updatePosition } = props;
	const center = {
		lat: lat,
		lng: long
	};
	const center_c = {
		lat: document.getElementById('center_lat').value,
		lng: document.getElementById('center_long').value
	};
	const [position, setPosition] = useState(center);
	const [circleColor, setCircleColor] = useState('transparent');
	const markerRef = useRef(null);

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					// Get the new position and update the state
					setPosition(marker.getLatLng());
				}
			}
		}),
		[]
	);
	const eventHandlersEnd = event => {
		var distance = getDistance(center_c, [event.target._latlng.lat, event.target._latlng.lng]);
		const center2 = {
			lat: event.target._latlng.lat,
			lng: event.target._latlng.lng
		};
		setPosition(center2);
		if (distance >= 101) {
			updatePosition(event.target._latlng.lat, event.target._latlng.lng, true);
		} else {
			updatePosition(event.target._latlng.lat, event.target._latlng.lng, false);
		}
	};

	const changeMarkerPosition = event => {
		var distance = getDistance(center_c, [event.target._latlng.lat, event.target._latlng.lng]);
		document.getElementById('cordinates').innerHTML =
			Number(event.target._latlng.lat).toFixed(4) + ' ,' + Number(event.target._latlng.lng).toFixed(4);
		if (distance >= 101) {
			setCircleColor('black');
			document.getElementById('confirmValidatebutton').disabled = true;
			document.getElementById('updateAddrees').innerHTML = pageLanguageContent['CLD113'];
			document.getElementById('newLat').innerHTML = event.target._latlng.lat;
			document.getElementById('newLong').innerHTML = event.target._latlng.lng;
			document.getElementById('closerPin').innerHTML = pageLanguageContent['CLD133'];
		} else {
			setCircleColor('transparent');
			document.getElementById('confirmValidatebutton').disabled = false;
			document.getElementById('updateAddrees').innerHTML = pageLanguageContent['CLD113'];
			document.getElementById('newLat').innerHTML = event.target._latlng.lat;
			document.getElementById('newLong').innerHTML = event.target._latlng.lng;
			document.getElementById('closerPin').innerHTML = '';
		}
	};

	function getDistance(origin, destination) {
		// return distance in meters
		var lon1 = toRadian(origin['lng']),
			lat1 = toRadian(origin['lat']),
			lon2 = toRadian(destination[1]),
			lat2 = toRadian(destination[0]);
		var deltaLat = lat2 - lat1;
		var deltaLon = lon2 - lon1;
		var a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
		var c = 2 * Math.asin(Math.sqrt(a));
		var EARTH_RADIUS = 6371;
		return c * EARTH_RADIUS * 1000;
	}

	function toRadian(degree) {
		return (degree * Math.PI) / 180;
	}

	return (
		<Marker
			draggable={true} // Enable dragging
			eventHandlers={eventHandlers} // Attach event handlers
			position={position} // Control the marker position with state
			ref={markerRef} // Reference for accessing the Leaflet marker instance
			onDragEnd={eventHandlersEnd}
			onDrag={changeMarkerPosition}
		>
			<Circle center={center_c} fillColor={circleColor} radius={100} color={circleColor} id='addressMapCircle' />
			<Popup minWidth={90}>
				<span>{orgName}</span>
			</Popup>
		</Marker>
	);
};

const AddressMap = props => {
	const { lat, long, dragMap, dragEndMap, dcolor, orgName, pageLanguageContent, updatePosition, map } = props;
	let map_center = {
		lat: lat,
		lng: long
	};
	// eslint-disable-next-line
	const [mapPosition, setMapPosition] = useState(map_center);
	return (
		<Map center={mapPosition} zoom={20} scrollWheelZoom={true} style={{ minHeight: 250 }} ref={map}>
			<TileLayer
				attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
				url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
			/>
			<DraggableMarker
				lat={lat}
				long={long}
				dragMap={dragMap}
				dragEndMap={dragEndMap}
				dcolor={dcolor}
				orgName={orgName}
				pageLanguageContent={pageLanguageContent}
				updatePosition={updatePosition}
			/>
		</Map>
	);
};

export default AddressMap;
